

export const orgId = {
  label: "Organization Id",
  type: "string",
  "minLength": 1
};

export const domain = {
  label: "Domain",
  type: "string",
  minLength: 3
};


export const description = {
  label: "Description",
  type: "string",
  minLength: 8
};

export const status = {
  type: "string",
};

export const domainId = {
  label: "Domain Id",
  type: "string",
  "minLength": 1
};